import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-conhecimento',
  templateUrl: './conhecimento.component.html',
  styleUrls: ['./conhecimento.component.css']
})
export class ConhecimentoComponent implements OnInit {

  loading: boolean = false;
  perguntas: Array<pergunta> = [];
  pesquisa: string = '';

  constructor(public userService: UserService, private router: Router, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.fetchPerguntas();
  }

  fetchPerguntas() {
    this.loading = true;
    this.userService.perguntasList().subscribe(
      (res: any) => {
        res.forEach(element => {
          this.perguntas.push({
            id: 'p' + element.id,
            pergunta: element.titulo,
            resposta: '',
            loading: false
          })
        });
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.loading = false
      },
      () => this.loading = false
    )
  }

  fetchPergunta(id: string) {
    const msgIndex = this.perguntas.findIndex(element => element.id === id);

    this.perguntas[msgIndex].loading = true;
    this.userService.fetchPergunta(Number(id.replace('p', ''))).subscribe(
      (res: any) => {
        this.perguntas[msgIndex].resposta = this.sanitized.bypassSecurityTrustHtml(res.resposta) as string;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.perguntas[msgIndex].loading = false
      },
      () => this.perguntas[msgIndex].loading = false
    )
  }
}

export interface pergunta {
  id: string;
  pergunta: string;
  resposta: string;
  loading: boolean;
}
